module.exports = __webpack_public_path__ + "c_static/img/3-4京东-查看评价.9036ac4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/电脑端轨迹加权/3-4京东-查看评价.jpg
// module id = o96Y
// module chunks = 33